export interface StoreCategory {
  partnerId: string;
  marketId: string;
  categoryId: string;
  name: string;
  packageIds: string[];
  showTabInStore: boolean;
}

export const allId = '__ALL__';
